export default "__VITE_ASSET__xuCbMrET__"